type HubspotContact = {
  email: string,
  company?: string,
  department_name?: string,
  firstname?: string,
  lastname?: string,
  phone?: string,
  address?: string,
  state?: string,
  zip?: string,
  id?: string,
  industry?: string,
  mobilephone?: string,
}
interface HsqWindow extends Window {
  _hsq: any;
}
declare const window: HsqWindow;
/**
 * HubSpotコンタクト情報を送る
 * @param contact 
 * @param path 
 */
export const putHubSpotContact = (contact: HubspotContact, path: string) => {
  const hubspotContact = { ...contact }

  const envName = import.meta.env.VITE_APP_ENV_NAME;
  if(envName !== 'prod'){
    // テスト環境の場合
    if(hubspotContact.company){
      hubspotContact.company = `${envName}${hubspotContact.company}`
    }
    if(hubspotContact.lastname){
      hubspotContact.lastname = `${envName}${hubspotContact.lastname}`
    }
  }
  // console.log(hubspotContact)

  const _hsq = window._hsq = window._hsq || [];
  _hsq.push(["identify", hubspotContact]);
  sendRouteToHubSpot(path)
}

/**
 * userAgentをHubSpotへ送る
 * @param {string} path 
 */
export const sendUserAgentToHubSpot = () => {
  const _hsq = window._hsq = window._hsq || [];

  const userAgentPseudoPath = `/?user_agent=${encodeURIComponent(navigator.userAgent)}`

  _hsq.push(['setPath', userAgentPseudoPath]);
  _hsq.push(['trackPageView']);
}

/**
 * HubSpotトラッキング情報を送る
 * @param {string} path 
 */
export const sendRouteToHubSpot = (path: string) => {
  const _hsq = window._hsq = window._hsq || [];

  const fullUrl = `${import.meta.env.VITE_APP_KCLOUD_URL}${path}`
  const parser = new URL(fullUrl);
  const realPath = fullUrl.replace(parser.origin, '')
  // console.log(realPath)

  _hsq.push(['setPath', realPath]);
  _hsq.push(['trackPageView']);
}